/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { STEPBody } from 'loaders/step/STEPBody';
import type { StyleAdapter } from 'loaders/step/StepStyleAdapter';
import type { AnyAction } from 'redux';

import type { UpdateVectorOperation } from '@frontend/partviewer/src/renderer/renderer-component';

export const handleUpdateVectors = (
  updatedVectors: UpdateVectorOperation[],
  obj: STEPBody,
  updatedVectorsCounter: () => AnyAction,
) => {
  updatedVectors.forEach((updatedVector) => {
    if (!updatedVector.name) {
      return;
    }
    const modelEntity: StyleAdapter | undefined = obj.vectorStyleByNameMap.get(
      updatedVector.name,
    );

    if (!modelEntity) {
      return;
    }

    // Parse Style from metaData and update metaData in STEP__model via adapter view
    if ('visible' in updatedVector || 'toLayer' in updatedVector) {
      if ('visible' in updatedVector) {
        modelEntity.visible = updatedVector.visible!;
      }
      if ('toLayer' in updatedVector) {
        modelEntity.layer = updatedVector.toLayer!;
      }
    }
  });
  // Increment to trigger react update
  updatedVectorsCounter();
};
